// Use native anchor navigation so keyboard, middle-click and modifier keys work.
// Scope this to this editor document; do not change image/script URLs or actions.
export default function installEditorLinkTargets(doc) {
  const prepareLink = (event) => {
    const element = event.target.nodeType === 1 ? event.target : event.target.parentElement;
    const link = element && element.closest("a[href]");
    if (!link || link.hasAttribute("download")) return;
    const href = link.getAttribute("href").trim();
    if (!href || href[0] === "#") return;
    let url;
    try {
      url = new URL(href, doc.baseURI);
    } catch (error) {
      return;
    }
    if (url.protocol !== "http:" && url.protocol !== "https:") return;
    // Fully qualified links to this document's anchors are still page navigation.
    const current = new URL(doc.URL);
    if (url.hash && url.origin === current.origin && url.pathname === current.pathname && url.search === current.search)
      return;
    link.setAttribute("target", "_blank");
    const rel = new Set((link.getAttribute("rel") || "").split(/\s+/).filter(Boolean));
    rel.delete("opener");
    rel.add("noopener");
    rel.add("noreferrer");
    link.setAttribute("rel", Array.from(rel).join(" "));
    link.setAttribute("data-editor-link", "editor-content-new-tab-v1");
  };
  const events = ["pointerdown", "focusin", "click", "auxclick"];
  events.forEach((name) => doc.addEventListener(name, prepareLink, true));
  return () => events.forEach((name) => doc.removeEventListener(name, prepareLink, true));
}
